module.exports = __webpack_public_path__ + "img/envelopeline.ca2331c4.svg";